/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Inactive/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'



/** @type {import('Simple/types.js').View} */
export default function Inactive({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/Email/Emails/Content/Email/PracticeHubAccountStatus/Inactive"
  
}) {
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 style="filled"
 type="orange"
 marginTop={dtSpaceXxxs}
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="Needs to activate Practice Hub account"
/>
)}
</TysiaTag>
{children}
</React.Fragment>)
}